import SignatureValidationModal from './SignatureValidationModal';

export default SignatureValidationModal;
